import React from 'react';
import { FormGroup } from 'react-bootstrap';
import PropTypes from 'prop-types';

import FormSwitch from '../../../../../../../../components/FormSwitch';

import * as types from '../../reducer/constants';

const FieldStatusSync = ({ form, dispatchServiceData }) => {
  const { auto_status } = form;

  const onChange = () => {
    dispatchServiceData({ type: types.EDIT_SERVICES_FORM_CHANGE_SYNC_STATUS, value: !auto_status })
  };

  return (
    <FormGroup className="form-group__sync-status">
      <FormSwitch
        id="auto_status"
        name="auto_status"
        checked={auto_status}
        onChange={onChange}
        tooltipText={(
          <p>
            Sync service status
            <br />
            {' '}
            with provider
          </p>
        )}
      >
        Sync service status with provider
      </FormSwitch>
    </FormGroup>
  );
};

FieldStatusSync.propTypes = {
  form: PropTypes.object,
  dispatchServiceData: PropTypes.func,
}

export default FieldStatusSync;
